import * as React from 'react';

import type { IconProps } from './types';

export const Hexagon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M464.107 12.833a95.787 95.787 0 0 1 95.785 0l360.454 208.108a95.782 95.782 0 0 1 47.892 82.952v416.215a95.783 95.783 0 0 1-47.892 82.952l-360.454 208.108a95.792 95.792 0 0 1-95.785 0L103.654 803.06a95.782 95.782 0 0 1-47.892-82.952V303.893a95.783 95.783 0 0 1 47.892-82.952L464.107 12.833z"
        fill={color}
      />
    </svg>
  )
);

export default Hexagon;
